import React, { Component } from 'react'
import { NavLink as RouterLink, Link } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'


import { Clearfix, Col, Row, Container } from '../../../../SPRINTA/atoms/Grid'
import CoverImage from '../../../../SPRINTA/atoms/CoverImage'
import FlexAlign from '../../../../SPRINTA/atoms/FlexAlign'
import Avatar from '../../../../SPRINTA/atoms/Avatar'
import Font from '../../../../SPRINTA/atoms/Font'
import HiddenInputFile from '../../../../SPRINTA/atoms/HiddenInputFile'
import Button from '../../../../SPRINTA/atoms/Button'
import Menu, { Item } from '../../../../SPRINTA/atoms/MenuResponsive'
import ProgressBar from '../../../../SPRINTA/atoms/ProgressBar'
import ActionBtnIcon from '../../../../SPRINTA/molecules/ActionBtnIcon'

import { modalLogin } from '../../../../store/actions/user'
import * as user from '../../../utils/user'

import T from '../../../../SPRINTA/translate/T'

import style from './style.css'

class Topbar extends Component {
    state = {
        user: null,
        page: null,
        toggleFollowLoading: false,
        coverUploading: null,
        avatarUploading: null
    }

    componentWillMount() {
        this.componentWillReceiveProps(this.props)
    }

    componentWillReceiveProps(props) {
        this.setState({
            page: props.page,
            user: props.data
        })
    }

    handleToggleFollow() {
        let following = this.state.user.followSummary.iAmFollowing

        if(!this.props.user.userData) {
            this.props.modalLogin('modal-login')
            return
        }

        var action = following ? 'unfollow' : 'follow'
        user.toggleFollow(this.state.user.profile.id, action)
        
        // let followers = this.state.user.followSummary.followers
        this.props.handleFollowToggle(action)
        // this.setState({
        //     user: {
        //         ...this.state.user,
        //         followSummary: {
        //             ...this.state.user.followSummary,
        //             iAmFollowing: following ? false : true,
        //             followers: !following ? followers + 1 : followers - 1
        //         }
        //     }
        // })

    }

    handleUploadAvatar(event) {
        user.uploadAvatar(event.target.files[0], progress => {
            this.setState({
                avatarUploading: progress
            })
        })
        .then(data => {
            this.setState({
                avatarUploading: null
            })
            this.props.handleUploaded('avatar', data.result.objectURL)
        })
    }

    handleUploadCover(event) {
        user.uploadCover(event.target.files[0], progress => {
            this.setState({
                coverUploading: progress
            })
        })
        .then(data => {
            this.setState({
                coverUploading: null
            })
            this.props.handleUploaded('cover', data.result.objectURL)
        })
    }

    render() {
        let user = this.state.user
        return (
            <div>
                <Clearfix>
                    <CoverImage
                        image={user.profile.coverPath}
                        shadow='600'
                        >
                        
                        <Container style={{ color: '#fff', height: '430px', padding: '30px 0' }}>
                            {user.isMe && (
                                <div className={style.cameraCover}>
                                    {this.state.coverUploading === null && (
                                        <div className={style.icon}>
                                            <HiddenInputFile
                                                    input={ref => this.inputCover = ref}
                                                    onChange={ event => this.handleUploadCover(event) }
                                                    accept="image/*"/>
                                            <ActionBtnIcon
                                                icon="camera"
                                                action={() => {
                                                    this.inputCover.click()                                                
                                                }}
                                            size={60} />
                                        </div>
                                    )}
                                    
                                    {this.state.coverUploading !== null && (
                                        <div className={style.imageProgress}>
                                            <ProgressBar progress={this.state.coverUploading} />
                                        </div>
                                    )}
                                </div>
                            )}

                            <FlexAlign style={{ height: '100%' }}>
                                <FlexAlign style={{ width: '100%' }}>
                                    <Col size='12 2' text="center" style={{ marginBottom: '30px' }}>
                                        <div className={style.avatarCenter}>
                                            <Avatar
                                                size={100}
                                                border="2px solid #fff"
                                                float="center"
                                                img={user.profile.avatarPath}
                                            >
                                            {user.isMe && (

                                                this.state.avatarUploading === null ? (
                                                    <Col hiddenLG className={style.cameraAvatar}>
                                                        <Row>
                                                            <Col hiddenLG style={{ height: '20px' }}></Col>

                                                            <div className={style.icon}>
                                                                <HiddenInputFile
                                                                    input={ref => this.inputAvatar = ref}
                                                                    onChange={ event => this.handleUploadAvatar(event) }
                                                                    accept="image/*"/>
                                                                <ActionBtnIcon
                                                                    icon="camera"
                                                                    action={() => {
                                                                        this.inputAvatar.click()
                                                                    }}
                                                                size={60} />
                                                            </div>

                                                        </Row>       
                                                    </Col>
                                                ) : (
                                                    <Col className={style.cameraAvatar} style={{ marginBottom: '30px' }}>
                                                        <Row>
                                                            <Col hiddenLG style={{ height: '20px' }}></Col>
                                                            <div className={style.imageProgress}>
                                                                <ProgressBar progress={this.state.avatarUploading} />                      
                                                            </div>   
                                                        </Row>       
                                                    </Col>
                                                )

                                            )}

                                            </Avatar>
                                        </div>
                                    </Col>

                                    <Col size='12 6' text='center left' style={{ marginBottom: '30px' }}>
                                    <Link to={`/user/${user.profile.username || user.profile.token}`}>
                                        <Font color='#fff' heading='2' size={40}>
                                            {user.profile.name}
                                        </Font>
                                    </Link>
                                    <Font size={15} weight='300' style={{ marginBottom: '20px' }}>
                                        {user.profile.userText}
                                    </Font>
                                    <Row>
                                        <Col size='6 4'>
                                            <Row>
                                                <Col size='6' text='center left'>
                                                    <Link to={`/user/${this.props.userLink}/following`}>
                                                        <Font size={14} weight={300} color='#fff'>
                                                            <b> {T.text('following')} </b> <br />
                                                            {user.followSummary.following}
                                                        </Font>
                                                    </Link>
                                                </Col>

                                                <Col size='6' text='center left'>
                                                    <Link to={`/user/${this.props.userLink}/followers`}>
                                                        <Font size={14} weight={300} color='#fff'>
                                                            <b> {T.text('followers')} </b> <br />
                                                            {user.followSummary.followers}
                                                        </Font>
                                                    </Link>
                                                </Col>
                                            </Row>
                                        </Col>
                                        {!user.isMe && (
                                            <Col size='6 4' text='center'>
                                                <Button
                                                    inline
                                                    theme={!user.followSummary.iAmFollowing ? 'primary' : 'dark'}
                                                    onClick={() => {
                                                        this.handleToggleFollow()
                                                    }}
                                                >
                                                    {user.followSummary.iAmFollowing ? 
                                                        `${T.txt('unfollow')}`
                                                     :
                                                        `${T.txt('follow')}`
                                                    }
                                                </Button>
                                            </Col>
                                        )}

                                        {/* <Col size='6 3' text='center left' float='center left'>
                                            <Valign height='50px'>
                                                <Row>
                                                    <Col size='3'>
                                                        <FontIcon name='facebook' size={30} />
                                                    </Col>
                                                    <Col size='3'>
                                                        <FontIcon name='twitter' size={30} />
                                                    </Col>
                                                    <Col size='3'>
                                                        <FontIcon name='linkedin' size={30} />
                                                    </Col>
                                                    <Col size='3'>
                                                        <FontIcon name='instagram' size={30} />
                                                    </Col>
                                                </Row>
                                            </Valign>
                                        </Col> */}
                                    </Row>
                                </Col>
                            
                                
                                    {this.props.challenges && (
                                        <Col size='12 4'>
                                            <div className={style.challengeMedals}>
                                                {this.props.challenges.map(challenge => (
                                                    <a key={challenge.token} className={!challenge.won ? style.pb : null} href={`/challenge/${challenge.token}`}>
                                                        <img src={challenge.medal} alt={challenge.title} style={{ maxWidth: '100%' }} />
                                                    </a>
                                                ))}

                                                {this.props.challenges.lenght > 0 && (
                                                    <RouterLink to={`/user/${this.props.userLink}/challenges`}>
                                                        <div className={style.iconPlus}>
                                                            ...
                                                        </div>
                                                    </RouterLink>
                                                )}
                                            </div>
                                        </Col>
                                    )}
                                </FlexAlign>

                            </FlexAlign>
                        </Container>
                    </CoverImage>
                </Clearfix>
                {user.isMe && (
                    <Clearfix style={{ backgroundColor: '#2b2b29' }}>
                        <Container style={{ position:'relative' }}>
                            <Menu>
                                <RouterLink to={`/user/${this.props.userLink}/`} exact isActive={ () => !this.props.page }>
                                    <Item active={ !this.props.page }>{T.text('my_page')}</Item>
                                </RouterLink>
                                <RouterLink to={`/user/${this.props.userLink}/subscriptions`} isActive={ () => this.props.page === 'inscriptions' }>                            
                                    <Item active={ ['inscriptions', 'subscriptions'].indexOf(this.props.page) > -1 }>{T.text('my_inscriptions')}</Item>
                                </RouterLink>
                                <RouterLink to={`/user/${this.props.userLink}/events`} isActive={ () => this.props.page === 'events' }>                                                        
                                    <Item active={ this.props.page === 'events' }>{T.text('my_events')}</Item>
                                </RouterLink>
                                <RouterLink to={`/user/${this.props.userLink}/config`} isActive={ () => this.props.page === 'config' }>              
                                    <Item active={ this.props.page === 'config' }>{T.text('configs')}</Item>
                                </RouterLink>
                            </Menu>
                        </Container>
                    </Clearfix>
                )}
                
            </div>
        )
    }
}
const mapStateToProps = store => ({
    user: store.user
})
const mapDispatchToProps = dispatch => bindActionCreators({
    modalLogin
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Topbar)


// WEBPACK FOOTER //
// ./src/App/pages/Profile/Topbar/index.js